import { atom, useAtom, useSetAtom } from "jotai";
import { PaymentMethodEnum } from "../utils/enum";

export const defaultPosOrderPayment = PaymentMethodEnum.CASH;
export const posOrderPaymentAtom = atom(defaultPosOrderPayment);

const usePosOrderPayment = () => {
  const atom = useAtom(posOrderPaymentAtom);
  return atom;
};

export const useSetPosOrderPayment = () => useSetAtom(posOrderPaymentAtom);

export default usePosOrderPayment;
